import createAction from "../../app/createAction";
import {
    ADD_LITE_TRADE_SUBSCRIPTION,
    ADD_MARKET_DATA_CANDLE_WATCH_ACTION,
    ADD_MARKET_DATA_WATCH_ACTION,
    CANCEL_LITE_TRADE_ORDER_ACTION,
    CANCEL_LITE_TRADE_ORDER_FAILURE,
    CANCEL_LITE_TRADE_ORDER_SUCCESS,
    UPDATE_LITE_TRADE_ORDER_ACTION,
    UPDATE_LITE_TRADE_ORDER_FAILURE,
    UPDATE_LITE_TRADE_ORDER_SUCCESS,
    CLOSE_LITE_TRADE_POSITION_ACTION,
    CLOSE_LITE_TRADE_POSITION_FAILURE,
    CLOSE_LITE_TRADE_POSITION_SUCCESS,
    CREATE_LITE_TRADE_ORDER_ACTION,
    CREATE_LITE_TRADE_ORDER_FAILURE,
    CREATE_LITE_TRADE_ORDER_SUCCESS,
    GET_LITE_TRADE_ASSETS_ACTION,
    GET_LITE_TRADE_ASSETS_FAILURE,
    GET_LITE_TRADE_ASSETS_SUCCESS,
    GET_LITE_TRADE_TOKEN_ACTION,
    GET_LITE_TRADE_TOKEN_FAILURE,
    GET_LITE_TRADE_TOKEN_SUCCESS,
    INIT_LITE_TRADE_ACTION,
    INIT_LITE_TRADE_FAILURE,
    INIT_LITE_TRADE_SUCCESS,
    LOGIN_LITE_TRADE_ACTION,
    LOGIN_LITE_TRADE_FAILURE,
    LOGIN_LITE_TRADE_SUCCESS,
    LOGOUT_LITE_TRADE_ACTION,
    LOGOUT_LITE_TRADE_FAILURE,
    LOGOUT_LITE_TRADE_SUCCESS,
    OPEN_LITE_TRADE_POSITION_ACTION,
    OPEN_LITE_TRADE_POSITION_FAILURE,
    OPEN_LITE_TRADE_POSITION_SUCCESS,
    PING_LITE_TRADE_ACTION,
    PING_LITE_TRADE_FAILURE,
    PING_LITE_TRADE_SUCCESS,
    PROCESS_LITE_TRADE_ORDER_NOTIFICATION,
    PROCESS_LITE_TRADE_POSITION_NOTIFICATION,
    PROCESS_LITE_TRADE_REJECTED_ORDER_NOTIFICATION,
    REMOVE_LITE_TRADE_SUBSCRIPTION,
    REMOVE_MARKET_DATA_CANDLE_WATCH_ACTION,
    REMOVE_MARKET_DATA_WATCH_ACTION,
    SET_LITE_TRADE_ACCOUNT_METRICS,
    SET_LITE_TRADE_ACCOUNT_PORTFOLIO,
    UPDATE_MARKET_DATA,
    UPDATE_MARKET_DATA_CANDLE,
    UPDATE_LITE_TRADE_POSITION_ACTION,
    UPDATE_LITE_TRADE_POSITION_SUCCESS,
    UPDATE_LITE_TRADE_POSITION_FAILURE,
    GET_LITE_TRADE_ACCOUNT_STAT_PL_FAILURE,
    GET_LITE_TRADE_ACCOUNT_STAT_PL_SUCCESS,
    GET_LITE_TRADE_ACCOUNT_STAT_PL_ACTION,
} from "./liteTradeConstants";

export const getLiteTradeTokenAction = (payload) => createAction(GET_LITE_TRADE_TOKEN_ACTION, payload);
export const getLiteTradeTokenSuccess = (payload) => createAction(GET_LITE_TRADE_TOKEN_SUCCESS, payload);
export const getLiteTradeTokenFailure = (payload) => createAction(GET_LITE_TRADE_TOKEN_FAILURE, payload);

export const initLiteTradeAction = (payload) => createAction(INIT_LITE_TRADE_ACTION, payload);
export const initLiteTradeSuccess = (payload) => createAction(INIT_LITE_TRADE_SUCCESS, payload);
export const initLiteTradeFailure = (payload) => createAction(INIT_LITE_TRADE_FAILURE, payload);

export const pingLiteTradeAction = (payload) => createAction(PING_LITE_TRADE_ACTION, payload);
export const pingLiteTradeSuccess = (payload) => createAction(PING_LITE_TRADE_SUCCESS, payload);
export const pingLiteTradeFailure = (payload) => createAction(PING_LITE_TRADE_FAILURE, payload);

export const loginLiteTradeAction = (payload) => createAction(LOGIN_LITE_TRADE_ACTION, payload);
export const loginLiteTradeSuccess = (payload) => createAction(LOGIN_LITE_TRADE_SUCCESS, payload);
export const loginLiteTradeFailure = (payload) => createAction(LOGIN_LITE_TRADE_FAILURE, payload);

export const logoutLiteTradeAction = (payload) => createAction(LOGOUT_LITE_TRADE_ACTION, payload);
export const logoutLiteTradeSuccess = (payload) => createAction(LOGOUT_LITE_TRADE_SUCCESS, payload);
export const logoutLiteTradeFailure = (payload) => createAction(LOGOUT_LITE_TRADE_FAILURE, payload);

export const addLiteTradeSubscription = (payload) => createAction(ADD_LITE_TRADE_SUBSCRIPTION, payload);
export const removeLiteTradeSubscription = (payload) => createAction(REMOVE_LITE_TRADE_SUBSCRIPTION, payload);
export const setLiteTradeAccountMetrics = (payload) => createAction(SET_LITE_TRADE_ACCOUNT_METRICS, payload);
export const setLiteTradeAccountPortfolio = (payload) => createAction(SET_LITE_TRADE_ACCOUNT_PORTFOLIO, payload);

export const getLiteTradeAssetsAction = (payload) => createAction(GET_LITE_TRADE_ASSETS_ACTION, payload);
export const getLiteTradeAssetsSuccess = (payload) => createAction(GET_LITE_TRADE_ASSETS_SUCCESS, payload);
export const getLiteTradeAssetsFailure = (payload) => createAction(GET_LITE_TRADE_ASSETS_FAILURE, payload);

export const updateMarketDataAction = (payload) => createAction(UPDATE_MARKET_DATA, payload); // Note that this action has been hidden in console by middleware
export const updateMarketDataCandleAction = (payload) => createAction(UPDATE_MARKET_DATA_CANDLE, payload); // Note that this action has been hidden in console by middleware

export const addMarketDataWatchAction = (payload) => createAction(ADD_MARKET_DATA_WATCH_ACTION, payload);
export const removeMarketDataWatchAction = (payload) => createAction(REMOVE_MARKET_DATA_WATCH_ACTION, payload);

export const addMarketDataCandleWatchAction = (payload) => createAction(ADD_MARKET_DATA_CANDLE_WATCH_ACTION, payload);
export const removeMarketDataCandleWatchAction = (payload) => createAction(REMOVE_MARKET_DATA_CANDLE_WATCH_ACTION, payload);

export const processLiteTradePositionNotificationAction = (payload) =>
    createAction(PROCESS_LITE_TRADE_POSITION_NOTIFICATION, payload);
export const processLiteTradeOrderNotificationAction = (payload) =>
    createAction(PROCESS_LITE_TRADE_ORDER_NOTIFICATION, payload);
export const processLiteTradeRejectedOrderNotificationAction = (payload) =>
    createAction(PROCESS_LITE_TRADE_REJECTED_ORDER_NOTIFICATION, payload);

/**
 * @deprecated use openLiteTradePositionAction/closeLiteTradePositionAction
 */
export const createLiteTradeOrderAction = (payload) => createAction(CREATE_LITE_TRADE_ORDER_ACTION, payload);
export const createLiteTradeOrderSuccess = (payload) => createAction(CREATE_LITE_TRADE_ORDER_SUCCESS, payload);
export const createLiteTradeOrderFailure = (payload) => createAction(CREATE_LITE_TRADE_ORDER_FAILURE, payload);

export const openLiteTradePositionAction = (payload) => createAction(OPEN_LITE_TRADE_POSITION_ACTION, payload);
export const openLiteTradePositionSuccess = (payload) => createAction(OPEN_LITE_TRADE_POSITION_SUCCESS, payload);
export const openLiteTradePositionFailure = (payload) => createAction(OPEN_LITE_TRADE_POSITION_FAILURE, payload);

export const closeLiteTradePositionAction = (payload) => createAction(CLOSE_LITE_TRADE_POSITION_ACTION, payload);
export const closeLiteTradePositionSuccess = (payload) => createAction(CLOSE_LITE_TRADE_POSITION_SUCCESS, payload);
export const closeLiteTradePositionFailure = (payload) => createAction(CLOSE_LITE_TRADE_POSITION_FAILURE, payload);

export const cancelLiteTradeOrderAction = (payload) => createAction(CANCEL_LITE_TRADE_ORDER_ACTION, payload);
export const cancelLiteTradeOrderSuccess = (payload) => createAction(CANCEL_LITE_TRADE_ORDER_SUCCESS, payload);
export const cancelLiteTradeOrderFailure = (payload) => createAction(CANCEL_LITE_TRADE_ORDER_FAILURE, payload);

export const updateLiteTradeOrderAction = (payload) => createAction(UPDATE_LITE_TRADE_ORDER_ACTION, payload);
export const updateLiteTradeOrderSuccess = (payload) => createAction(UPDATE_LITE_TRADE_ORDER_SUCCESS, payload);
export const updateLiteTradeOrderFailure = (payload) => createAction(UPDATE_LITE_TRADE_ORDER_FAILURE, payload);

export const updateLiteTradePositionAction = (payload) => createAction(UPDATE_LITE_TRADE_POSITION_ACTION, payload);
export const updateLiteTradePositionSuccess = (payload) => createAction(UPDATE_LITE_TRADE_POSITION_SUCCESS, payload);
export const updateLiteTradePositionFailure = (payload) => createAction(UPDATE_LITE_TRADE_POSITION_FAILURE, payload);

export const getLiteTradeAccountStatPLAction = (payload) => createAction(GET_LITE_TRADE_ACCOUNT_STAT_PL_ACTION, payload);
export const getLiteTradeAccountStatPLSuccess = (payload) => createAction(GET_LITE_TRADE_ACCOUNT_STAT_PL_SUCCESS, payload);
export const getLiteTradeAccountStatPLFailure = (payload) => createAction(GET_LITE_TRADE_ACCOUNT_STAT_PL_FAILURE, payload);
